import { render, staticRenderFns } from "./FormPackage.vue?vue&type=template&id=713535b6&scoped=true&"
import script from "./FormPackage.vue?vue&type=script&lang=js&"
export * from "./FormPackage.vue?vue&type=script&lang=js&"
import style0 from "./FormPackage.vue?vue&type=style&index=0&id=713535b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713535b6",
  null
  
)

export default component.exports